import React, { FC } from 'react'
import { BydesignProductItem } from './components/bydesignProductItem'
import {
  Flex,
  Grid,
  GridItem,
  Spacer,
  Text,
} from '@sendoutcards/quantum-design-ui'


type BydesignProductGridProps = {
  title: string
  description: string
  productItems: { productId: string }[]
}
export const BydesignProductGrid: FC<BydesignProductGridProps> = ({
  title,
  description,
  productItems,
}) => {
  return (
    <Flex
      width="100%"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      inset={{ vertical: 'x6' }}
    >
      <Text type="title" content={title ?? ''} alignment="center" />
      <Text type="largeBody" content={description ?? ''} alignment="center" />
      <Spacer space="x6" />
      <Grid
        columnSize={280}
        rowSize={420}
        gap={16}
        maxWidth={
          productItems.length === 1
            ? 320
            : productItems.length === 2
            ? 672
            : 1300
        }
      >
        {productItems.map(item => (
          <GridItem key={item.productId} gridRowSpan={1} gridColSpan={1}>
            <BydesignProductItem productId={item.productId} />
          </GridItem>
        ))}
      </Grid>
    </Flex>
  )
}
